import ViewReportTemplate from './viewReport.html';
import ViewReportDataProviderModule from './viewReportDataProvider';
import TabsModule from './tabs/tabs';
import './viewReport.scss';

function ViewReportRouter($urlRouterProvider, $stateProvider) {
  $stateProvider
    .state('main.reports.view', {
      url: '/view?reportId&:global&tab',
      template: ViewReportTemplate,
      controller: ViewReportController,
      params: {
        report: null,
        tab: null
      },
      resolve: {
        permission: ($q, PermissionsService) => {
          return PermissionsService.canIGenerateReport()
            ? $q.resolve()
            : $q.reject('Route permission check failed: main.reports.view');
        }
      }
    });
}

function ViewReportController($scope,
                             $q,
                             $filter,
                             $state,
                             ViewReportDataProvider,
                             utils,
                             ToastsService) {

  const $t = $filter('translate');

  if (!$state.params.reportId) {

    // DEBUG
    console.warn('No Report ID specified');

    $state.go('main.reports.list');
    return;
  }

  // NOTE: Dirty hack for fast injecting ready-to-use data provider to child components
  ViewReportDataProvider.instance = new ViewReportDataProvider();
  let dataProvider = ViewReportDataProvider.instance;
  $scope.dataProvider = dataProvider;

  // #region Navigation Tabs
  $scope.tabs = [
    {
      id: 'details',
      name: $t('reports.view.tabs.details'),
      icon: 'far fa-file-alt',
    },
    {
      id: 'group',
      name: $t('reports.view.tabs.group'),
      icon: 'far fa-layer-group',
    },
    {
      id: 'history',
      name: $t('reports.view.tabs.history'),
      icon: 'far fa-history',
    }
  ];
  // #endregion

  init();

  function init() {
    $scope.initialLoading = true;

    dataProvider.reportResource.init()
      .then(() => {
        const report = dataProvider.reportResource.value;
        if (!report) {
          ToastsService.warn(null, $t('reports.errors.reportNotFound'));
          $state.go('main.reports.list');
          return $q.reject();
        }

        // Restore the active tab from the URL (so a reload stays on the same tab),
        // defaulting to 'history' for scheduled reports and 'details' otherwise.
        const validTabs = $scope.tabs.map(tab => tab.id);
        const urlTab = $state.params.tab;
        dataProvider.activeTab = validTabs.indexOf(urlTab) !== -1
          ? urlTab
          : (report.schedule ? 'history' : 'details');
        $scope.initialLoading = false;
      })
      .catch((err) => {
        $scope.initialLoading = false;
        if (err) {
          ToastsService.error(null, $t('reports.errors.getReportError'));
        }
      });

    // Keep the URL `tab` param in sync with the active tab (without reloading the view).
    $scope.$watch(() => dataProvider.activeTab, (tab) => {
      if (tab && tab !== $state.params.tab) {
        $state.go($state.current.name, { tab: tab }, { notify: false });
      }
    });

    $scope.$on('$destroy', () => {
      dataProvider.destroy();
      ViewReportDataProvider.instance = undefined;
      $('#approve-email-dialog').remove();
    });
  }

}

export default angular
  .module('main.reports.view', [
    ViewReportDataProviderModule,
    TabsModule,
  ])
  .config(ViewReportRouter)
  .name;
